import ReactDOM from 'react-dom'

import { lifecycle } from 'recompose'

export default <Props = {}>(
  handler: (props: Props) => void,
  eventName = 'click',
) =>
  lifecycle<Props, {}, any>({
    componentDidMount() {
      this.handleOutside = this.handleOutside.bind(this)

      this.toggleListeners(true)
    },

    componentWillUnmount() {
      this.toggleListeners(false)
    },

    handleOutside(event: MouseEvent) {
      // If no focus target is provided, we'll use this HOC as a way to locate the element
      const component = this.props.focusTarget || this

      if (!ReactDOM.findDOMNode(component)?.contains(event.target as Node)) {
        handler(this.props)
      }
    },

    toggleListeners(on: boolean) {
      const method: 'addEventListener' | 'removeEventListener' = on
        ? 'addEventListener'
        : 'removeEventListener'

      document[method](eventName, this.handleOutside, true)
    },
  })
